import * as budgets from './budgets';
import * as vehiclesMaintenance from './vehiclesMaintenance';
import * as vehiclesModels from './vehiclesModels';
import * as manageColors from './manageColors';
import * as manageColorsForm from './manageColorsForm';
import * as vehiclesHistoryColor from './vehiclesHistoryColor';
import * as vehiclesPriceColor from './vehiclesPriceColor';
import * as advisorManagement from './advisorManagement';
import * as clientManagement from './clientManagement';
import * as exemptionManagement from './exemptionManagement';
import * as extraData from './extraData';
import * as manageFlFiles from './manageFlFiles';
import * as vehiclesPriceColorLoad from './vehiclesPriceColorLoad';

const reducers = {
  ...budgets,
  ...vehiclesMaintenance,
  ...vehiclesModels,
  ...manageColors,
  ...manageColorsForm,
  ...vehiclesHistoryColor,
  ...vehiclesPriceColor,
  ...advisorManagement,
  ...clientManagement,
  ...exemptionManagement,
  ...extraData,
  ...manageFlFiles,
  ...vehiclesPriceColorLoad,
};

export default reducers;
